import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { PennyChatInput } from "@pcln/horizon-penny-components";
import { Box } from "pcln-design-system";
import { useContext, useEffect, useState } from "react";
import analytics from "../../analytics/analytics.js";
import { OpenMapButton } from "../Maps/OpenMapButton.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { useChatMessagesContext } from "../../hooks/useChatMessagesContext.js";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
import { useLoadingStateContext } from "../../hooks/useLoadingStateContext.js";
import { useRealTimeContext } from "../../hooks/useRealTimeContext.js";
import { submitChatMessages } from "../../submitChatMessages.js";
import ChatSendIcon from "../../svgs/ChatSendIcon.js";
import sanitizeInput from "../../utils/sanitizeInput.js";
import { ExpandableInput } from "../ExpandableInput/ExpandableInput.js";
import VoiceControlButton from "../Realtime/VoiceControlButton/VoiceControlButton.js";
const PennyExpandableInput = ({ submitChatMessagesOptions, isStandalone, styles, handleExpandableInputHeight })=>{
    const [showGlowEffect, setShowGlowEffect] = useState(false);
    const { submitChatMessagesPayload, setErrorMessage, logFirstMessageSubmitted, isDisablingInput, setiValues, isMobile, showLandingPage } = useContext(ChatbotDataContext);
    const { isLoading } = useLoadingStateContext();
    const { setOpenErrorComponent } = useChatUIContext();
    const { chatMessages, setChatMessages } = useChatMessagesContext();
    const { setStartRealTime, isRealtime } = useRealTimeContext();
    const VoiceIcon = isRealtime ? /*#__PURE__*/ jsx(VoiceControlButton, {
        isExpandableTextArea: true
    }) : null;
    const SendIcon = /*#__PURE__*/ jsx(ChatSendIcon, {});
    const inputBoxStyle = {
        padding: '8px',
        ...styles.inputStyle,
        ...'style' in styles.inputStyle ? styles.inputStyle?.style : {}
    };
    const handleSubmit = (msg)=>{
        setErrorMessage('');
        const chatMessage = {
            role: 'user',
            content: sanitizeInput(msg),
            date: new Date()
        };
        const promptMessage = {
            role: 'user',
            content: sanitizeInput(msg)
        };
        const updatedChatMessages = [
            ...chatMessages,
            chatMessage
        ];
        setChatMessages([
            ...chatMessages,
            chatMessage
        ]);
        submitChatMessages({
            submitChatMessagesPayload: {
                ...submitChatMessagesPayload,
                prompts: [
                    promptMessage
                ],
                includeSpeech: true
            },
            setOpenErrorComponent,
            chatMessages: updatedChatMessages,
            ...submitChatMessagesOptions
        })?.catch((e)=>analytics.logError({
                message: e?.message,
                source: 'PennyExpandableInput submitChatMessages'
            }));
        logFirstMessageSubmitted(chatMessages);
    };
    useEffect(()=>{
        setShowGlowEffect(true);
        const timer = setTimeout(()=>setShowGlowEffect(false), 1500);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    const shouldPersonalizedGreeting = setiValues?.shouldPersonalizedGreeting;
    const inputClassesNotPersonalized = isMobile ? 'fixed bottom-5' : 'absolute -bottom-10';
    const inputClassesPersonalized = isMobile ? 'fixed bottom-5 left-0 right-0' : 'absolute -bottom-8 left-0 right-0';
    const resolvedInputClasses = shouldPersonalizedGreeting ? inputClassesPersonalized : inputClassesNotPersonalized;
    const containerHeight = showLandingPage ? '100%' : '';
    if (!shouldPersonalizedGreeting) return /*#__PURE__*/ jsx(Fragment, {
        children: setiValues?.shouldEnablePennyChatInput ? /*#__PURE__*/ jsx("div", {
            className: "mb-15 relative h-full",
            children: /*#__PURE__*/ jsxs("div", {
                className: `${inputClassesNotPersonalized} flex w-full flex-col gap-4 pl-2 pr-2 sm:pr-0`,
                children: [
                    /*#__PURE__*/ jsx(OpenMapButton, {
                        isLoading: isLoading,
                        isStandalone: isStandalone,
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ jsx(PennyChatInput, {
                        showGlowEffect: showGlowEffect,
                        disabled: isLoading || isDisablingInput,
                        onSubmitClickHandler: (msg)=>handleSubmit(msg),
                        onVoiceClickHandler: function() {
                            setStartRealTime(true);
                        }
                    })
                ]
            })
        }) : /*#__PURE__*/ jsx(Box, {
            style: inputBoxStyle,
            children: /*#__PURE__*/ jsxs("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ jsx(OpenMapButton, {
                        isLoading: isLoading,
                        isStandalone: isStandalone,
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ jsx(ExpandableInput, {
                        placeholder: 'Ask Penny a Question',
                        variant: 'glow',
                        maxLineHeight: 3,
                        voiceIcon: VoiceIcon,
                        submitIcon: SendIcon,
                        disabled: isLoading || isDisablingInput,
                        onSubmitClickHandler: (msg)=>handleSubmit(msg),
                        onVoiceClickHandler: function() {
                            setStartRealTime(true);
                        },
                        voiceIconClassName: "mr-2",
                        submitIconClassName: "",
                        onHeightChange: handleExpandableInputHeight
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ jsx(Box, {
        width: "100%",
        display: "flex",
        height: containerHeight,
        children: setiValues?.shouldEnablePennyChatInput ? /*#__PURE__*/ jsx("div", {
            className: "mb-15 relative h-full w-full",
            children: /*#__PURE__*/ jsxs("div", {
                className: `${resolvedInputClasses} flex w-full flex-col gap-4 pl-2 pr-2 sm:pr-0`,
                children: [
                    /*#__PURE__*/ jsx(OpenMapButton, {
                        isLoading: isLoading,
                        isStandalone: isStandalone,
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ jsx(PennyChatInput, {
                        showGlowEffect: showGlowEffect,
                        disabled: isLoading || isDisablingInput,
                        onSubmitClickHandler: (msg)=>handleSubmit(msg),
                        onVoiceClickHandler: function() {
                            setStartRealTime(true);
                        }
                    })
                ]
            })
        }) : /*#__PURE__*/ jsx(Box, {
            style: inputBoxStyle,
            children: /*#__PURE__*/ jsxs("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ jsx(OpenMapButton, {
                        isLoading: isLoading,
                        isStandalone: isStandalone,
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ jsx(ExpandableInput, {
                        placeholder: 'Ask Penny a Question',
                        variant: 'glow',
                        maxLineHeight: 3,
                        voiceIcon: VoiceIcon,
                        submitIcon: SendIcon,
                        disabled: isLoading || isDisablingInput,
                        onSubmitClickHandler: (msg)=>handleSubmit(msg),
                        onVoiceClickHandler: function() {
                            setStartRealTime(true);
                        },
                        voiceIconClassName: "mr-2",
                        submitIconClassName: "",
                        onHeightChange: handleExpandableInputHeight
                    })
                ]
            })
        })
    });
};
const components_PennyExpandableInput = PennyExpandableInput;
export { components_PennyExpandableInput as default };
